import React, {Component} from 'react';
import { inject, observer } from 'mobx-react';
import moment from "moment";

import AirModal from '../../../../../common/components/AirModal';
import AirButton from '../../../../../common/components/AirButton';

import './EditRouteTask.css';
import AirInput from "../../../../../common/components/AirInput";
import RouteIcon from "../../../../../common/icons/RouteIcon";

@inject('translationsStore', 'routeTaskStore', 'commonStore')
@observer
export default class EditRouteTask extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  show = (record) => {
    const date = moment(record.date).add(new Date(record.date).getTimezoneOffset(), 'm');
    record.time = date;
    record.date = date;
    this.setState({ visible: true, ...record });
  };

  hide = () => {
    this.setState({
      visible: false,
      name: undefined,
      date: undefined,
      time: undefined,
      note: undefined,
      positionDetails: null
    });
  };

  onChange = (e) => {
    this.setState({ groupId: e.target.value });
  };

  transformToGeoJson = (address) => {
    const {lng, lat} = address;
    delete address.lng;
    delete address.lat;

    return {
      position: {
        type: 'Point',
        coordinates: [lng, lat]
      },
      positionDetails: address
    };
  };

  onSubmit = () => {
    const { id, name, position, date, time, note, positionDetails } = this.state;
    const { commonStore, routeTaskStore } = this.props;

    const formattedDatetime = `${date.format('YYYY-MM-DD')} ${time.format('HH:mm')}`;

    this.hide();
    commonStore.setLoading(true);
    routeTaskStore.edit(id, name, position, formattedDatetime, note, positionDetails).then(() => {
      commonStore.setLoading(false);
    });
  };

  disabledDateBeforeToday = (current) => {
    return current && current < moment().startOf('day');
  };

  render() {
    const { translationsStore } = this.props;
    const { visible, name, position, date, time, note, positionDetails } = this.state;

    const disabled = !name || !position || !date || !time;

    return (
      <AirModal
        className="CreateRouteTaskModal"
        width="840px"
        visible={visible}
        icon={<RouteIcon style={{ width: '60px', height: '40px' }} />}
        title={translationsStore.translate('routePlanning.editRoute.modal.title')}
        onCancel={this.hide}
        okButton={<AirButton disabled={disabled} size="large" light label={translationsStore.translate('routePlanning.editRoute.modal.buttonLabel')} />}
        onOk={() => !disabled && this.onSubmit()}
      >
        <AirInput label={translationsStore.translate('routePlanning.editRoute.modal.name')} value={name} onChange={(e) => this.setState({ name: e.target.value })} />
        {!!positionDetails && <AirInput
          label={translationsStore.translate('routePlanning.editRoute.modal.address')}
          disabled={true}
          value={positionDetails.metaData && positionDetails.metaData.address? positionDetails.metaData.address : positionDetails.label}
        />}
        {this.state.visible && (
          <AirInput
            type="location"
            label={translationsStore.translate('routePlanning.editRoute.modal.selectNewAddress')}
            onSelect={(location) => this.setState({ ...this.transformToGeoJson(location) })}
            onCancelSearch={() => this.setState({ position: null })}
            center={{
              lat: 45.316267,
              lng: 8.857712,
            }}
          />
        )}
        <div className="RouteInputRow">
          <AirInput
            type="date"
            label={translationsStore.translate('routePlanning.editRoute.modal.date')}
            value={date}
            onChange={(date) => this.setState({ date })}
            disabledDate={this.disabledDateBeforeToday}
          />
          <AirInput type="time" label={translationsStore.translate('routePlanning.editRoute.modal.time')} value={time} onChange={(time) => this.setState({ time })} />
        </div>
        <AirInput label={translationsStore.translate('routePlanning.editRoute.modal.note')} value={note} onChange={(e) => this.setState({ note: e.target.value })} />
      </AirModal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/RouteTaskDashboard/RouteTaskTable/EditRouteTask/EditRouteTask.js